import { FC } from "react";
import { Heading } from "@chakra-ui/react";

type Props = {
  title: string;
}

export const AssetTitle: FC<Props> = ({ title }) => (
  <Heading
    as="h4"
    fontSize={["md", "lg"]}
    fontWeight="medium"
    dangerouslySetInnerHTML={{ __html: title }}
  />
);
